module.exports = __webpack_public_path__ + "static/media/GALAD Иллюминатор LED.837b37b3.jpg";